import { Localized } from "@fluent/react"
import { Alert, Box, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { useState } from "react"
import { CancelButton } from "../../../app/components/CancelButton"
import { DeleteButton } from "../../../app/components/DeleteButton"
import { useAppDispatch } from "../../../app/hooks"
import { deleteCompanySSOSetting } from "./CompanySSOApi"
import { showError, showSuccess } from "../../notifications/notificationsSlice"

interface DeleteCompanySSOSettingsDialogProps {
    companyTenantId: number;
    onDeleteSuccess: (id: number) => void;
    onCancel: () => void;
}

export const DeleteCompanySSOSettingsDialog: React.FC<DeleteCompanySSOSettingsDialogProps> = ({ companyTenantId, onDeleteSuccess, onCancel }) => {
    const dispatch = useAppDispatch()

    const [serverError, setServerError] = useState("")
    const [saving, setSaving] = useState<boolean>(false)

    const handleConfirm = async () => {
        try {
            setSaving(true)

            const result = await dispatch(deleteCompanySSOSetting(companyTenantId))
            if (deleteCompanySSOSetting.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onDeleteSuccess(companyTenantId)
            } else {
                let errorMsg = "error"

                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title
                    }
                }

                setServerError(errorMsg)
            }
        }
        catch {
            dispatch(showError("error"))
        }
        finally {
            setSaving(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Localized id="company-sso-settings-delete-title">
                        <span>_Usuń ustawienia SSO</span>
                    </Localized>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Localized id="company-sso-settings-delete-question">
                    <span>_Czy na pewno chcesz usunąć te ustawienia SSO?</span>
                </Localized>
                {
                    serverError && <Alert sx={{ marginTop: 1 }} onClose={() => setServerError("")} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <DeleteButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>
    )
}